export const DELETE_VIDEO_REQUEST = 'DELETE_VIDEO/REQUEST';
export const DELETE_VIDEO_SUCCESS = 'DELETE_VIDEO/SUCCESS';
export const DELETE_VIDEO_FAILURE = 'DELETE_VIDEO/FAILURE';
